export default __webpack_public_path__ + "img/open-chat.4c2c664d.svg";